// extracted by mini-css-extract-plugin
module.exports = {"adminpanel_container":"AdminPanel_adminpanel_container__3xpon","adminpanel_wrapper":"AdminPanel_adminpanel_wrapper__21Q37","Admin_citylist":"AdminPanel_Admin_citylist__3ZRCz"};